<template>
  <div class="container ContactUs">
    <div class="row">
      <div
        class="col-md-4 col-lg-4 col-sm-12"
        data-aos="fade-down"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
      >
        <b-card
          id="card2"
          text-variant="light"
          class="text-center draw"
          style="border-radius: 0 !important; height: 50vh !important"
        >
          <template #header>
            <h2 class="display-9 my-3 font-weight-bold">
              <b-icon class="animate2" icon="house-door-fill"></b-icon>
            </h2>
            <div class="dez-separator bg-primary"></div>
            <h4 class="mb-0 display-8 my-1 font-weight-bold">Contact</h4>
          </template>

          <b-card-body>
            <!--            <b-card-title>Card Title</b-card-title>-->
            <!--            <b-card-sub-title class="mb-2">Card Sub Title</b-card-sub-title>-->
            <b-card-text>
              +963-123456789
            </b-card-text>
          </b-card-body>
        </b-card>
      </div>
      <div
        class="col-md-4 col-lg-4 col-sm-12"
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
      >
        <b-card
          id="card2"
          text-variant="light"
          class="text-center draw"
          style="border-radius: 0 !important; height: 50vh !important"
        >
          <template #header>
            <h2 class="display-9 my-3 font-weight-bold">
              <b-icon class="animate2" icon="telephone-fill"></b-icon>
            </h2>
            <div class="dez-separator bg-primary"></div>
            <h4 class="mb-0 display-8 my-1 font-weight-bold">Address</h4>
          </template>

          <b-card-body>
            <!--            <b-card-title>Card Title</b-card-title>-->
            <!--            <b-card-sub-title class="mb-2">Card Sub Title</b-card-sub-title>-->
            <b-card-text>
                Damadcus, Syria
            </b-card-text>
          </b-card-body>
        </b-card>
      </div>
      <div
        class="col-md-4 col-lg-4 col-sm-12"
        data-aos="fade-down"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
      >
        <b-card
          id="card2"
          text-variant="light"
          class="text-center draw"
          style="border-radius: 0 !important; height: 50vh !important"
        >
          <template #header>
            <h2 class="display-9 my-3 font-weight-bold">
              <b-icon
                class="animate2"
                icon="
                inboxes-fill"
              ></b-icon>
            </h2>
            <div class="dez-separator bg-primary"></div>
            <h4 class="mb-0 display-8 my-1 font-weight-bold">Mail</h4>
          </template>

          <b-card-body>
            <!--            <b-card-title>Card Title</b-card-title>-->
            <!--            <b-card-sub-title class="mb-2">Card Sub Title</b-card-sub-title>-->
            <b-card-text>
              info@beetaxi.com
            </b-card-text>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  props: {
    msg: String,
  },
};
</script>

<style scoped>
.MarketingBrief {
  /*background-color: #2c3e50;*/
  height: 90vh;
}
.animate1,
.animate2,
.animate3 {
  position: relative;
  top: 0;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s; /*font-size: 5em;*/
  /*float: left;*/
  /*margin: 3px 20px;*/
  /*-webkit-transition: 0.6s ease-out;*/
  /*-moz-transition:  0.6s ease-out;*/
  /*transition:  0.6s ease-out;*/
}
#card1:hover .animate1 {
  top: -10px;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  /*-webkit-transform: rotateY(720deg);*/
  /*-moz-transform: rotateY(720deg);*/
  /*transform: rotateY(720deg);*/
}
#card2:hover .animate2 {
  top: -10px;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  /*-webkit-transform: rotateY(720deg);*/
  /*-moz-transform: rotateY(720deg);*/
  /*transform: rotateY(720deg);*/
}
#card3:hover .animate3 {
  top: -10px;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  /*-webkit-transform: rotateY(720deg);*/
  /*-moz-transform: rotateY(720deg);*/
  /*transform: rotateY(720deg);*/
}
.draw {
  background-color: #1e2c3844;
  border: 1px;
  box-sizing: border-box;
  box-shadow: inset 0 0 0 2px transparent;
  font-size: inherit;
  position: relative;
  vertical-align: middle;
  -webkit-transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
  transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
}
.draw > div {
  position: relative;
  z-index: 1;
}
.draw:before,
.draw:after {
  box-sizing: inherit;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
}

.draw {
  -webkit-transition: color 0.25s;
  transition: color 0.25s;
}
.draw:before,
.draw:after {
  border: 2px solid transparent;
  width: 0;
  height: 0;
}
.draw:before {
  top: 0;
  left: 0;
}
.draw:after {
  bottom: 0;
  right: 0;
}
.draw:hover:before,
.draw:hover:after {
  width: 100%;
  height: 100%;
}
.draw:hover:before {
  -webkit-transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
  transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
}
.draw:hover:before {
  border-top-color: rgb(255, 222, 32);
  border-right-color: rgb(255, 222, 32);
}
.draw:hover:after {
  -webkit-transition: border-color 0s ease-out 0.5s, width 0.25s ease-out 0.5s,
    height 0.25s ease-out 0.75s;
  transition: border-color 0s ease-out 0.5s, width 0.25s ease-out 0.5s,
    height 0.25s ease-out 0.75s;
}
.draw:hover:after {
  border-bottom-color: rgb(255, 222, 32);
  border-left-color: rgb(255, 222, 32);
}
.dez-separator {
  display: inline-block;
  height: 3px;
  width: 50px;
  margin-bottom: 10px;
  position: relative;
  /*-moz-transition: all 0.5s;*/
  /*-webkit-transition: all 0.5s;*/
  /*transition: all 0.5s;*/
}
.draw:hover .dez-separator {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  width: 80px;
}
.dez-separator {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.bg-primary {
  background-color: #ffffff !important;
}
/*@media (prefers-reduced-motion: no-preference) {*/
/*  .square {*/
/*    animation-name: transation-up;*/
/*    animation-duration: 3s;*/
/*    animation-iteration-count: 3;*/
/*  }*/
/*}*/
</style>
